/**
 * PCM 2026 Theme - Special Submission Forms
 *
 * Handles legacy review submission and art-upload forms separately from the
 * unified lead form handler plugin.
 */
(function($, window, document) {
  'use strict';

  const config = window.pcmSubmissionForms || {};
  const allowedUploadExtensions = [
    'pdf',
    'eps',
    'tiff',
    'jpg',
    'jpeg',
    'bmp',
    'png',
    'gif',
    'indd',
    'psd',
    'ai',
    'xls',
    'xlsx',
    'csv'
  ];

  function getAjaxUrl($form) {
    return $form.attr('action') || config.ajaxUrl || '/wp-admin/admin-ajax.php';
  }

  function setButtonLoading($button, isLoading, loadingText) {
    if (!$button.length) {
      return;
    }

    if (isLoading) {
      $button.data('pcmOriginalHtml', $button.html());
      $button.html(loadingText || 'Submitting...');
      $button.prop('disabled', true);
      return;
    }

    $button.html($button.data('pcmOriginalHtml') || $button.html());
    $button.prop('disabled', false);
  }

  function showFormMessage($form, type, message) {
    const className = type === 'error' ? 'alert-danger' : 'alert-success';
    let $message = $form.siblings('.pcm-submission-form-message').first();

    if (!$message.length) {
      $message = $('<div class="pcm-submission-form-message alert" role="status" aria-live="polite"></div>');
      $form.before($message);
    }

    $message
      .removeClass('alert-success alert-danger')
      .addClass(className)
      .html(message)
      .show();
  }

  function showError($form, message) {
    const errorHtml = '<div class="message" style="text-align:center;padding:30px;"><h2>Oops! There was an error.</h2><p>' + message + '</p></div>';

    if ($.fancybox && $.fancybox.open) {
      $.fancybox.open(errorHtml);
      return;
    }

    showFormMessage($form, 'error', message);
  }

  function getAjaxErrorMessage(jqXHR, fallback) {
    if (jqXHR && jqXHR.responseJSON && jqXHR.responseJSON.data && jqXHR.responseJSON.data.message) {
      return jqXHR.responseJSON.data.message;
    }

    return fallback;
  }

  function getCheckedRating($form) {
    return $form.find('input[name="reviews-submit__rating"]:checked').val();
  }

  function validateReviewForm($form) {
    const author = $.trim($form.find('[name="reviews-submit__author"]').val());
    const rating = getCheckedRating($form);
    const review = $.trim($form.find('[name="reviews-submit__review"]').val());

    if (!author) {
      return 'Please enter your name.';
    }

    if (!rating) {
      return 'Please choose a star rating.';
    }

    if (!review) {
      return 'Please enter your review.';
    }

    return '';
  }

  function handleReviewSuccess($form, response) {
    const message = response && response.data && response.data.message
      ? response.data.message
      : 'Thank you! Your review has been submitted and will show on this page soon.';

    const $legacyHeading = $('.reviews-submit__heading');
    const $legacyText = $('.reviews-submit__text');

    if ($legacyHeading.length || $legacyText.length) {
      $legacyHeading.text('Thank you!');
      $legacyText.text(message);
      $form.remove();
      return;
    }

    $form.replaceWith('<div class="alert alert-success pcm-submission-form-message" role="status">' + message + '</div>');
  }

  function initReviewForms() {
    $(document).on('submit.pcmReviewSubmit', '.review-submit-form, #reviews-submit__form', function(event) {
      event.preventDefault();

      const $form = $(this);
      const validationMessage = validateReviewForm($form);

      if (validationMessage) {
        showFormMessage($form, 'error', validationMessage);
        return;
      }

      const $button = $form.find('button[type="submit"], input[type="submit"]').first();
      const formData = new FormData(this);

      if (!formData.has('action')) {
        formData.append('action', 'pcm_create_review');
      }

      setButtonLoading($button, true, 'Submitting...');

      $.ajax({
        url: getAjaxUrl($form),
        method: 'POST',
        data: formData,
        contentType: false,
        processData: false
      }).done(function(response) {
        if (response && response.success === false) {
          showError($form, response.data && response.data.message ? response.data.message : 'Please check the review form and try again.');
          return;
        }

        handleReviewSuccess($form, response);
      }).fail(function(jqXHR) {
        showError($form, getAjaxErrorMessage(jqXHR, 'Please try again, or open a chat and a real person will finish your request.'));
      }).always(function() {
        setButtonLoading($button, false);
      });
    });
  }

  function getUploadFiles(input) {
    return input && input.files ? Array.from(input.files) : [];
  }

  function validateEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function validatePhone(phone) {
    return /^[2-9]\d{9}$/.test(phone.replace(/\D/g, ''));
  }

  function getFileExtension(fileName) {
    const parts = String(fileName || '').split('.');
    return parts.length > 1 ? parts.pop().toLowerCase() : '';
  }

  function getFormValue($form, fieldName) {
    return $.trim($form.find('[name="' + fieldName + '"]').val() || '');
  }

  function validateUploadForm($form) {
    const company = getFormValue($form, 'submitart-upload__company');
    const legacyName = getFormValue($form, 'submitart-upload__name');
    const firstName = getFormValue($form, 'submitart-upload__first-name');
    const lastName = getFormValue($form, 'submitart-upload__last-name');
    const email = getFormValue($form, 'submitart-upload__email');
    const phone = getFormValue($form, 'submitart-upload__phone');
    const fileInput = $form.find('[name="submitart-upload__input-upload[]"]')[0];
    const files = getUploadFiles(fileInput);
    const recaptchaField = $form.find('[name="hiddenRecaptcha"]');

    if (!company) {
      return 'Please enter your company name.';
    }

    if (!legacyName && !firstName) {
      return 'Please enter your first name.';
    }

    if (!legacyName && !lastName) {
      return 'Please enter your last name.';
    }

    if (!validateEmail(email)) {
      return 'Please enter a valid email address.';
    }

    if (!validatePhone(phone)) {
      $form.find('[name="submitart-upload__phone"]').addClass('is-invalid');
      return 'Please enter a valid 10-digit phone number (no leading 1).';
    }

    if (!files.length) {
      return 'Please choose at least one file to upload.';
    }

    for (let i = 0; i < files.length; i++) {
      const extension = getFileExtension(files[i].name);

      if (allowedUploadExtensions.indexOf(extension) === -1) {
        return 'The file "' + files[i].name + '" is not an accepted file type.';
      }
    }

    if (recaptchaField.length && $('.g-recaptcha').length && !recaptchaField.val()) {
      return 'Please complete the reCAPTCHA before uploading.';
    }

    return '';
  }

  function updateUploadFileSummary($form) {
    const fileInput = $form.find('[name="submitart-upload__input-upload[]"]')[0];
    const files = getUploadFiles(fileInput);
    const $summary = $form.find('[data-upload-file-summary]');

    if (!$summary.length) {
      return;
    }

    if (!files.length) {
      $summary.text('No files selected');
      return;
    }

    if (files.length === 1) {
      $summary.text(files[0].name);
      return;
    }

    $summary.text(files.length + ' files selected');
  }

  function initUploadDropzone($form) {
    const $dropzone = $form.find('.submit-art-upload-dropzone');
    const $fileInput = $form.find('[name="submitart-upload__input-upload[]"]');

    if (!$dropzone.length || !$fileInput.length) {
      return;
    }

    $dropzone.on('dragenter.pcmUploadForm dragover.pcmUploadForm', function(event) {
      event.preventDefault();
      event.stopPropagation();
      $dropzone.addClass('is-dragging');
    });

    $dropzone.on('dragleave.pcmUploadForm dragend.pcmUploadForm', function(event) {
      event.preventDefault();
      event.stopPropagation();
      $dropzone.removeClass('is-dragging');
    });

    $dropzone.on('drop.pcmUploadForm', function(event) {
      const dataTransfer = event.originalEvent && event.originalEvent.dataTransfer;

      event.preventDefault();
      event.stopPropagation();
      $dropzone.removeClass('is-dragging');

      if (!dataTransfer || !dataTransfer.files || !dataTransfer.files.length) {
        return;
      }

      try {
        $fileInput[0].files = dataTransfer.files;
      } catch (error) {
        return;
      }

      $fileInput.trigger('change');
    });
  }

  function setUploadProgress($form) {
    const formHeight = $form.innerHeight();
    const $uploadArea = $form.find('.submit-art-upload-form__fields, .submit-art-upload-dropzone');

    $('.submitart-upload-submit__heading').text('Upload in Progress...');
    $('.submitart-upload-submit__text').text("This may take a moment. Please don't refresh or leave this page until the upload is complete.");

    if ($uploadArea.length) {
      if (!$form.children('.row--loading').length) {
        $form.append('<div class="row--loading submit-art-upload-loading" style="min-height:' + Math.min(formHeight, 420) + 'px;"><div class="loader"><div class="loader__spinner"></div></div></div>');
      }

      $form.attr('aria-busy', 'true');
      $uploadArea.hide();
      return;
    }

    if (!$form.siblings('.row--loading').length) {
      $form.after('<div class="row--loading" style="min-height:' + formHeight + 'px;"><div class="loader"><div class="loader__spinner"></div></div></div>');
    }

    $form.attr('aria-busy', 'true').hide();
  }

  function clearUploadProgress($form) {
    const $uploadArea = $form.find('.submit-art-upload-form__fields, .submit-art-upload-dropzone');

    if ($uploadArea.length) {
      $form.attr('aria-busy', 'false');
      $uploadArea.show();
      $form.children('.row--loading').remove();
      return;
    }

    $form.attr('aria-busy', 'false').show();
    $form.siblings('.row--loading').remove();
  }

  function getUploadResponseHtml(response) {
    if (response && response.data && response.data.html) {
      return response.data.html;
    }

    if (typeof response === 'string') {
      return response;
    }

    return '<div>Your upload was received.</div>';
  }

  function handleUploadSuccess($form, response) {
    const $uploadArea = $form.find('.submit-art-upload-form__fields, .submit-art-upload-dropzone');

    $('.submitart-upload-submit__heading').text('Upload Complete!');
    $('.submitart-upload-submit__text').text('See below for details.');
    $('.submitart-upload-submit .row--loading').remove();
    $('#upload-response').html(getUploadResponseHtml(response));

    if ($uploadArea.length) {
      $uploadArea.remove();
      return;
    }

    $form.remove();
  }

  function initUploadForms() {
    const $uploadForm = $('#submitart-upload-submit__form');

    if (!$uploadForm.length) {
      return;
    }

    window.recaptchaCallback = function() {
      const $recaptchaField = $('#hiddenRecaptcha');

      $recaptchaField.val('1').trigger('change');
      $('#submitart-upload-submit__form button[type="submit"]').prop('disabled', false);
    };

    initUploadDropzone($uploadForm);
    updateUploadFileSummary($uploadForm);

    $uploadForm.on('change.pcmUploadForm input.pcmUploadForm', 'input, textarea', function() {
      $(this).removeClass('is-invalid');
      $uploadForm.siblings('.pcm-submission-form-message').remove();

      if ($(this).is('[type="file"]')) {
        updateUploadFileSummary($uploadForm);
      }
    });

    $uploadForm.on('submit.pcmUploadForm', function(event) {
      event.preventDefault();

      const $form = $(this);
      const validationMessage = validateUploadForm($form);
      const $button = $form.find('button[type="submit"], input[type="submit"]').first();

      if (validationMessage) {
        showFormMessage($form, 'error', validationMessage);
        return;
      }

      const formData = new FormData(this);

      if (!formData.has('action')) {
        formData.append('action', 'pcm_create_clientupload');
      }

      setButtonLoading($button, true, 'Uploading...');
      setUploadProgress($form);

      $.ajax({
        url: config.ajaxUrl || '/wp-admin/admin-ajax.php',
        method: 'POST',
        data: formData,
        contentType: false,
        processData: false
      }).done(function(response) {
        if (response && response.success === false) {
          clearUploadProgress($form);
          showError($form, response.data && response.data.message ? response.data.message : 'Please check the upload form and try again.');
          return;
        }

        handleUploadSuccess($form, response);
      }).fail(function(jqXHR) {
        clearUploadProgress($form);
        showError($form, getAjaxErrorMessage(jqXHR, 'Please try again, or open a chat and a real person will finish your request.'));
      }).always(function() {
        setButtonLoading($button, false);
      });
    });
  }

  $(function() {
    initReviewForms();
    initUploadForms();
  });
})(jQuery, window, document);
